import { SectionCard, SectionCardTitle } from "@/components";
import CareerImageGrid from "../ImageGrid";
import { CareerDetails } from "../CareerDetails";
import { FeaturedJobs } from "../FeaturedJobs";
import { EmployeeTestemonials } from "../EmployeeTestemonials";

const CareerMain = () => {
  return (
    <>
      <SectionCard className="px-4 lg:px-[90px] mx-0 h-auto">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
          <div className="lg:w-1/2 w-full lg:mt-25">
            <SectionCardTitle>Career</SectionCardTitle>
            <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px]   text-justify  text-[#415667] mt-4">
              Intron Life Sciences offers a professional, ethical, and growth-driven work environment where innovation and talent thrive.
            </p>
          </div>
          <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
          <div className="w-fit">
            <CareerImageGrid/>
          </div>
          </div>
        </div>
      </SectionCard>
      <CareerDetails />
      <FeaturedJobs />
      <EmployeeTestemonials />
    </>
  );
};

export default CareerMain;
